import React from 'react';
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "./Swiper_image.css";

const slides = [
  
  "/assets/images/about_us/swipper1.png",
  "/assets/images/about_us/swiper_img2.png",
  "/assets/images/about_us/swipper1.png",
  "/assets/images/about_us/swiper_img2.png",
  
];

const Swiper_image = () => {
  return (
     
    <section className="swiper-section">
      <div className="container">
      
      <Swiper
        className="swiper-main"
        modules={[Autoplay]}        
      
        autoplay={{ delay: 2000 }}
        loop={true}
        slidesPerView={1.5}
        spaceBetween={25}

         breakpoints={{
           0: { slidesPerView: 1.5 },
          320: { slidesPerView: 1.5 },
          575: { slidesPerView: 1.8,spaceBetween:"10" },
          768: { slidesPerView: 1.5 },
          992: {slidesPerView:1.5},
           1200: {slidesPerView:1.5},
           1400: {slidesPerView:1.8},
        }}
              
      >
        {slides.map((img, index) => (
          <SwiperSlide key={index}>
            <div className="swiper-slide-wrapper">
              <img
                className="swiper-banner-image1"
                src={process.env.PUBLIC_URL + img}
                alt={`Slide ${index+1}`}
              />              

            </div>
          </SwiperSlide>
        ))}
      </Swiper>
      </div>
    </section>
  );
};

export default Swiper_image;